import { Alert, Button, Form, Input, Select } from 'antd'
import Page from '../../../../ui/Page';
import useApplications from '../useApplications';
import useFetchData from '../../../../hooks/useFetchData';
import { ApplicationTypeDtoResponse } from '../../../../interfaces/Applications/response/ApplicationTypeDtoResponse';
import { ApplicationService } from '../../../../services/ApplicationService';
import Center from '../../../../ui/Center';
import { PlusCircleOutlined } from '@ant-design/icons';
import { ApplicationDtoRequest } from '../../../../interfaces/Applications/request/ApplicationDtoRequest';
import { ApplicationInfoDtoRequest } from '../../../../interfaces/Applications/request/ApplicationInfoDtoRequest';
import { useHistory } from 'react-router-dom';
import DataTypeComponent from '../DataTypeComponent';
import { MaskedInput } from 'antd-mask-input';
import React, { useEffect, useState } from 'react';
import UserService from '../../../../services/userService';
import { StudentService } from '../../../../services/StudentService';
import { StudentProfileDtoResponse } from '../../../../interfaces/Student/StudentProfileDtoResponse';



const CreateStudentApplicationPage = () => {
    const [user, setUser] = useState<StudentProfileDtoResponse>({} as StudentProfileDtoResponse);
    const [form] = Form.useForm();
    const [documentForm] = Form.useForm();

    const { data: types } = useFetchData<ApplicationTypeDtoResponse[]>(ApplicationService.getApplicationTypesUsed, true);
    const { data, methods } = useApplications({});
    const history = useHistory();
    const [fileLabel, setFileLabel] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        UserService.getProfileByPrincipal()
            .then(response => {
                setUser(response.data);
            })
            .catch(error => {
                console.error("Error", error);
            });
    }, []);

    const handleFormSubmit = async (values: any) => {
        setLoading(true);

        const applicationDtoRequest: ApplicationDtoRequest = {
            typeId: values.typeId,
            lang: values.lang,
            reason: values.reason,
            phone: values.phone,
        };

        const applicationInfoDtoRequestList: ApplicationInfoDtoRequest[] = await Promise.all(
            data.applicationInfoTypes.map(async (type) => {
                let value;

                if (type.prefix === 'study_discount_type_item' && type.id === 39) {
                    value = JSON.stringify(await values[type.id]);
                } else if (type.prefix === 'study_discount_type_item') {
                    value = await values[type.id + 1];
                } else if (type.id === 39 || type.id === 41) {
                    value = JSON.stringify(await values[type.id]);
                } else if (type.prefix === 'admission_doc_id') {
                    await documentForm.validateFields().then(async (documentValues) => {
                        await StudentService.updateAdmissionDocument({
                            ...documentValues,
                        }).then(async (res) => {
                            if (res.status === 200) {
                                await StudentService.getAdmissionDocument()
                                    .then(({ data: admissionDocInfo }) => {
                                        value = JSON.stringify({
                                            id: admissionDocInfo.id,
                                            name: admissionDocInfo.identityDocumentType.name,
                                            number: admissionDocInfo.identityDocumentNumber,
                                            date: admissionDocInfo.identityDocumentIssueDate,
                                        });
                                    });
                            }
                        });
                    });
                } else {
                    value = await values[type.id];
                }

                return {
                    applicationInfoTypesId: type.id,
                    value,
                };
            })
        );

        await methods.handleCreate({
            applicationDtoRequest,
            applicationInfoDtoRequestList,
        })
            .finally(() => {
                setLoading(false);
                form.resetFields();
                history.push('/applications');
            });
    }

    return (
        <Page title={"Create application request"}>
            <Center lg={18}>
                <Form layout='vertical' form={form}
                    onFinish={async (values) => {
                        await handleFormSubmit(values);
                    }}
                >
                    <Form.Item
                        label="Language"
                        name="lang"
                        rules={[{ required: true, message: 'Please select a language!' }]}>
                        <Select onSelect={(value) => methods.handleSelectLanguage(value)}>
                            {data.languages?.map(lang => (
                                <Select.Option key={lang.id} value={lang.id}>
                                    {`${lang.name}`}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {data.selectedLanguage && (
                        <>
                            <Form.Item
                                label="Application type"
                                name="typeId"
                                valuePropName="checked"
                                rules={[{ required: true, message: 'Please choose status!' }]}>
                                <Select onSelect={methods.handleSelectApplicationType}>
                                    {types?.map(type => (
                                        <Select.Option key={type.id} value={type.id}>
                                            {data.selectedLanguage === 3 ? type.nameEn : data.selectedLanguage === 1 ? type.nameRu : type.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            {(form.getFieldValue('typeId') === 15 || form.getFieldValue('typeId') === 13) && (
                                <Alert
                                    type="info"
                                    message="Внимание!"
                                    description={
                                        <>
                                            До подачи заявки на обходной лист обучающийся должен выполнить:
                                            <ol>
                                                {/* <li>СДАТЬ ID карточку в Департамент технического обеспечения (каб. С1.2.255);</li> */}
                                                <li>СДАТЬ ключи от локера в Департамент по хозяйственной работе – коменданту (каб. С1.1.140);</li>
                                                <li>СДАТЬ книги в библиотеку (С1.1 этаж);</li>
                                                <li>СДАТЬ комнату в общежитии в Департамент воспитательной и социальной работы (каб. С1.1.323) (в случае проживания).</li>
                                            </ol>
                                            Только после этого подать заявку на обходной лист!!
                                        </>
                                    }
                                    style={{ marginBottom: 24 }}
                                    showIcon
                                />
                            )}

                            <Form.Item
                                label="Reason"
                                name="reason"
                                rules={[{ required: true, message: 'Please write a comment!' }]}>
                                {data.applicationReasons.length > 0 ? (
                                    <Select onSelect={(value) => form.setFieldValue('reason', value)}>
                                        {data.applicationReasons.map(reason => (
                                            <Select.Option key={reason.id} value={data.selectedLanguage === 3 ? reason.nameEn : data.selectedLanguage === 1 ? reason.nameRu : reason.name}>
                                                {data.selectedLanguage === 3 ? reason.nameEn : data.selectedLanguage === 1 ? reason.nameRu : reason.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                ) : <Input.TextArea />}
                            </Form.Item>

                            <Form.Item
                                label="Phone"
                                name="phone"
                                rules={[{ required: true, message: 'Please write a your phone!' }]}>
                                <MaskedInput mask={'+0-(000)-000-00-00'} placeholder="+_-(___)-___-__-__" />
                            </Form.Item>
                            {data.applicationInfoTypes.map((type, i) => (
                                <DataTypeComponent key={i} type={type} form={form} langId={data?.selectedLanguage ? data.selectedLanguage : 2} fileLabel={fileLabel} setFileLabel={setFileLabel} documentForm={documentForm} />
                            ))}
                            <Form.Item>
                                <Button type="primary" icon={<PlusCircleOutlined />} htmlType="submit" loading={loading} disabled={loading}>
                                    Create
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form>
                {(form.getFieldValue('typeId') === 16) && user.iik && user.bik && (
                    <Alert
                        type="info"
                        message="Внимание!"
                        description={
                            <>
                                <p>Ваши текущие банковские реквизиты:</p>
                                <p><b>ИИК:</b> {user.iik}</p>
                                <p><b>БИК:</b> {user.bik}</p>
                            </>
                        }
                        style={{ marginBottom: 24 }}
                        showIcon
                    />
                )}
            </Center>
        </Page>

    )
}

export default CreateStudentApplicationPage
